import { type FC, useEffect, useState } from 'react';

import { type LinkItemProps } from '@vakantiesnl/components/src/molecules/LinkList/LinkList';
import { createLinks } from '@vakantiesnl/components/src/utils/contentfulMenuHelpers';
import { filterUserMenu } from '@vakantiesnl/services/src/contentful/mapper';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';
import { useGetUserProfile } from '@vakantiesnl/services/src/hooks/queries';
import { useGetUserMenu } from '@vakantiesnl/services/src/hooks/queries/useGetUserMenu';

import { BaseMenu } from './BaseMenu';

export const MainMenu: FC = () => {
	const [links, setLinks] = useState<LinkItemProps[]>([]);
	const { userMenu } = useGetUserMenu();
	const microCopies = useMicroCopyContext();
	const { userProfile } = useGetUserProfile();

	useEffect(() => {
		if (userMenu) {
			const filteredUserMenu = filterUserMenu([userMenu], microCopies);
			setLinks(createLinks(filteredUserMenu));
		}
	}, [userMenu, microCopies]);

	if (!userMenu) {
		return null;
	}

	//TODO: this should be added back once the non-JS retrieval of userData has been added
	// if (!userData) {
	// 	return null;
	// }

	const accoOwner = userProfile?.isAccoOwner || false;

	const filteredLinks = links
		? accoOwner
			? links
			: links.filter((linkItem) => linkItem.text !== microCopies['userMenu.mijnAccommodaties.linkText'])
		: [];

	return <BaseMenu userData={userProfile} links={filteredLinks} />;
};
